import React from "react";
import "./index.scss";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import { TOGGLE_WAIT_TIME_MESSAGE_POPUP } from "./reducers/document-management-reducer";
import { useDispatch } from "react-redux";
export interface IWaitTimeMessageModal {}

const WaitTimeMessageModal: React.FC<IWaitTimeMessageModal> = (props) => {
  const dispatch = useDispatch();
  const onWaitTimeMessageOkButtonClick = () => {
    dispatch({
      type: TOGGLE_WAIT_TIME_MESSAGE_POPUP,
      data: { isWaitTimeMessagePopupVisible: false },
    });
    window.open(window.location.href);
  };
  return (
    <MdaePopup
      mdaeTitleRender={() => {
        return (
          <MdaePopupTitle closePopupHandler={false} isHideCloseButton={true}>
            Alert
          </MdaePopupTitle>
        );
      }}
      className="wait-time-modal"
      width={460}
      height={355}
      showTitle={true}
      deferRendering={false}
      hideOnOutsideClick={false}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_WAIT_TIME_MESSAGE_POPUP,
          reducerName: "documentManagementReducer",
          widgetOptionBindings: {
            visible: "isWaitTimeMessagePopupVisible",
          },
        },
      ]}
      onTitleRendered={(e) => {
        e.component.registerKeyHandler("escape", function(arg) {
          arg.stopPropagation();
        });
      }}
      mdaeContentRender={() => {
        return (
          <MdaePopupContent>
            <div className="wait-time-modal-content">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexFlow: "column",
                }}
              >
                <div>
                  <i className="fa fa-bell-o" style={{ fontSize: "50px" }}></i>
                </div>
                <div className=" mdae-standalone-label wait-time-message-content">
                  <div>
                    This document has taken longer than 20 seconds to upload.
                    You can continue working in the new tab which will open
                    after OK button click. Please do not close the tab where the
                    upload is processing until you receive an upload success
                    message.
                  </div>
                </div>
              </div>
            </div>
          </MdaePopupContent>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id="btnWaitTimeMessage"
                role={"primary"}
                onClick={onWaitTimeMessageOkButtonClick}
              >
                OK
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

export default WaitTimeMessageModal;
